import { Application } from "@hotwired/stimulus";
import AjaxPopoverController from "./controllers/AjaxPopoverController";
import AtLeastOneCheckedController from "./controllers/AtLeastOneCheckedController";
import BadgeCollectedController from "./controllers/BadgeCollectedController";
import CheckoutAddressEntryController from "./controllers/CheckoutAddressEntryController";
import ClaimsQualifyingProductsController from "./controllers/ClaimsQualifyingProductsController";
import CodeEntryController from "./controllers/CodeEntryController";
import CredentialsController from "./controllers/CredentialsController";
import FavouriteController from "./controllers/FavouriteController";
import FeedController from "./controllers/FeedController";
import FeedItemController from "./controllers/FeedItemController";
import FeedLikeButtonController from "./controllers/FeedLikeButtonController";
import FeedPostCreateController from "./controllers/FeedPostCreateController";
import GifPauseController from "./controllers/GifPauseController";
import FormController from "./controllers/FormController";
import HelpController from "./controllers/HelpController";
import LayoutAccountDropdownController from "./controllers/LayoutAccountDropdownController";
import LayoutController from "./controllers/LayoutController";
import IntercomController from "./controllers/IntercomController";
import LayoutSearchSuggestController from "./controllers/LayoutSearchSuggestController";
import LogUserActionController from "./controllers/LogUserActionController";
import MembershipRequestController from "./controllers/MembershipRequestController";
import MyEventsCalendarController from "./controllers/MyEventsCalendarController";
import MyEventsDetailController from "./controllers/MyEventsDetailController";
import NominationCreateController from "./controllers/NominationCreateController";
import PrizeController from "./controllers/PrizeController";
import ProfileController from "./controllers/ProfileController";
import ProfileEditPictureController from "./controllers/ProfileEditPictureController";
import ReferAFriendController from "./controllers/ReferAFriendController";
import RegistrationProfileController from "./controllers/RegistrationProfileController";
import RewardController from "./controllers/RewardController";
import RewardsController from "./controllers/RewardsController";
import SalesTargetVisualisation from "./controllers/SalesTargetVisualisation";
import ScratchcardController from "./controllers/ScratchcardController";
import SignInVerifySmsController from "./controllers/SignInVerifySmsController";
import SpinTheWheelController from "./controllers/SpinTheWheelController";
import SpinnerController from "./controllers/SpinnerController";
import ConfirmController from "./controllers/ConfirmController";
import SpendRequestController from "./controllers/SpendRequestController";
import TelephoneNumberController from "./controllers/TelephoneNumberController";
import TwoFASettingsController from "./controllers/TwoFASettingsController";
import UserNotificationsController from "./controllers/UserNotificationsController";
import VerifyMobileNumberController from "./controllers/VerifyMobileNumberController";
import "./plugins";

const application = Application.start();
application.register("ajax-popover", AjaxPopoverController);
application.register("at-least-one-checked", AtLeastOneCheckedController);
application.register("badge-collected", BadgeCollectedController);
application.register("checkout-address-entry", CheckoutAddressEntryController);
application.register("claims-qualifying-products", ClaimsQualifyingProductsController);
application.register("code-entry", CodeEntryController);
application.register("credentials", CredentialsController);
application.register("favourite", FavouriteController);
application.register("feed-item", FeedItemController);
application.register("feed-like-button", FeedLikeButtonController);
application.register("feed-post-create", FeedPostCreateController);
application.register("gif-pause", GifPauseController);
application.register("feed", FeedController);
application.register("form", FormController);
application.register("help", HelpController);
application.register("layout", LayoutController);
application.register("layout-account-dropdown", LayoutAccountDropdownController);
application.register("layout-search-suggest", LayoutSearchSuggestController);
application.register("log-user-action", LogUserActionController);
application.register("membership-request", MembershipRequestController);
application.register("my-events-calendar", MyEventsCalendarController);
application.register("my-events-detail", MyEventsDetailController);
application.register("nomination-create", NominationCreateController);
application.register("prize", PrizeController)
application.register("profile", ProfileController);
application.register("profile-edit-picture", ProfileEditPictureController);
application.register("refer-a-friend", ReferAFriendController);
application.register("registration-profile", RegistrationProfileController);
application.register("reward", RewardController);
application.register("rewards", RewardsController);
application.register("sales-target-visualisation", SalesTargetVisualisation);
application.register("scratchcard", ScratchcardController);
application.register("sign-in-verify-sms", SignInVerifySmsController);
application.register("spin-the-wheel", SpinTheWheelController);
application.register("spinner", SpinnerController);
application.register("telephone-number", TelephoneNumberController);
application.register("two-fa-settings", TwoFASettingsController);
application.register("user-notifications", UserNotificationsController);
application.register("confirm", ConfirmController);
application.register("spend-request", SpendRequestController);
application.register("intercom", IntercomController);
application.register("verify-mobile-number", VerifyMobileNumberController);